import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import styled from 'styled-components';
import { Container } from './styles';
import { TimeIcon } from 'shared/ui/icons/time';

interface TimeButtonProps {
	onClick: () => void;
	text: string;
	selected: boolean;
}

const ImageContainer = styled.div`
	height: 27px;
`;

export const TimeButton: FC<TimeButtonProps> = ({ onClick, text, selected }) => {
	return (
		<Container onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined} onTouchStart={onClick} selected={selected}>
			<Flex
				$direction="column"
				$alignItems="center"
				$cursor="pointer"
				$padding="3px"
			>
				<ImageContainer>
					<TimeIcon reverse={selected} />
				</ImageContainer>
				<div>{text}</div>
			</Flex>
		</Container>
	);
};
